import { useTranslation } from 'react-i18next';
import onlineDelivery from 'public/static/images/vdp/online-delivery.png';
import { colors } from 'components/styles/variables';
import Image from './Image';
import Caption from './Caption';

export default function Delivery(): JSX.Element {
  const { t } = useTranslation();
  return (
    <>
      <div className="image-container">
        <Image src={onlineDelivery} />
      </div>
      <Caption>
        <div className="online-container">
          <h3 className="online-delivery">{t('vdp.onlineDelivery')}</h3>
          <div>{t('vdp.deliveryCaption')}</div>
        </div>
      </Caption>
      <style jsx>{`
        .image-container {
          line-height: 0;
        }

        .online-container {
          display: flex;
          flex-direction: column;
        }

        .online-delivery {
          margin: 0;
          padding: 0;
          text-transform: uppercase;
          font-size: 16px;
          font-weight: 700;
          letter-spacing: 0.2px;
          color: ${colors.ALB1};
        }

        .cars-delivered {
          font-size: 16px;
          font-weight: 400;
          color: ${colors.BLACK};
        }
      `}</style>
    </>
  );
}
